import "./NoSubscriptionSystemPromptComponent.scss";
import template from "./NoSubscriptionSystemPromptComponent.html";
import {IComponentOptions, IOnDestroy} from "angular";
import {ReplaySubject} from "rxjs";

export const NoSubscriptionPrompt = "tfNoSubscriptionPrompt";

export function noSubscriptionPrompt(): IComponentOptions {
    return {
        template,
        controller: NoSubscriptionSystemPromptComponentController
    };
}

export class NoSubscriptionSystemPromptComponentController implements IOnDestroy {
    private readonly destroy$ = new ReplaySubject<boolean>(1);
    /** @ngInject */
    public constructor() {}

    public $onDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
